import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';
import { MyHttpClient } from "../http-client";

const ROSDHeaders = ["riderId", "amount", "orderIds", "serviceDetailIds"];
const ROSDSample = {
  riderId: "61702d357ac72e5b29ed0046",
  amount: "100",
  orderIds: "62ab32e31ac88c0cbac7733d|62ab32e31ac88c0cbac7733e|62ab32e31ac88c0cbac7733f",
  serviceDetailIds: "5c4317d8487a78564f91f4c7|5c4317d8487a78564f91f4c8"
};

const RSDHeaders = ["riderId", "amount", "serviceDetailIds"];
const RSDSample = {
  riderId: "61702d357ac72e5b29ed0046",
  amount: "100",
  serviceDetailIds: "5c4317d8487a78564f91f4c7"
};

const RCHeaders = ["riderId", "amount", "cityId"];
const RCSample = {
  riderId: "61702d357ac72e5b29ed0046",
  amount: "100",
  cityId: "5c30ae72f0c2c508a5be17ca",
};

const ROCHeaders = ["riderId", "amount", "cityId", "orderIds"];
const ROCSample = {
  riderId: "61702d357ac72e5b29ed0046",
  amount: "100",
  cityId: "5c30ae72f0c2c508a5be17ca",
  orderIds: "62ab32e31ac88c0cbac7733d|62ab32e31ac88c0cbac7733e|62ab32e31ac88c0cbac7733f",
};

export const BulkPayArrayFields = ["orderIds", "serviceDetailIds"]

const sampleFileFactoryMap = new Map([
  ["ROSD", { headers: ROSDHeaders, sample: ROSDSample }],
  ["RSD", { headers: RSDHeaders, sample: RSDSample }],
  ["RC", { headers: RCHeaders, sample: RCSample }],
  ["ROC", { headers: ROCHeaders, sample: ROCSample }],
]) as Map<string, { headers: string[], sample: any }>

export type BulkPayTransactionConfig = {
  headers: string[];
  sampleData: any[];
  name: string;
  displayName: string;
  remarks?: string[];
  roles?: string[];
  factoryType?: string;
  disabled?: boolean;
  type: string;
};

@Injectable()
export class BulkPayService {
  public transactionTypes: BulkPayTransactionConfig[] = environment.bulkPayTransactions
    .map(t => ({
      ...t,
      headers: sampleFileFactoryMap.get(t.factoryType).headers,
      sampleData: [sampleFileFactoryMap.get(t.factoryType).sample]!,
    }))

  private static apiRoot = environment.server;

  constructor(private httpClient: MyHttpClient) { }

  initiateBulkPay(data: any): Promise<any> {
    return this.httpClient.post(BulkPayService.apiRoot + '/api/bulkpay/initiate', data).toPromise();
  }

  validateBulkPayFile(data: any): Promise<any> {
    return this.httpClient.post(BulkPayService.apiRoot + '/api/bulkpay/validate', data).toPromise();
  }

  fetchBulkPayHistory(params: any) {
    return this.httpClient.get(BulkPayService.apiRoot + '/api/bulkpay', params).toPromise();
  }

  downloadResult(fileId: string) {
    return this.httpClient.get(BulkPayService.apiRoot + '/api/bulkpay/' + fileId).toPromise();
  }
}
